// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
  max-width: 100%;
}
.wn-review {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/app/screening-module/income-wizard/phases/stream-phase/stream-types/stream-review-worknumber.component.less"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;EACA,eAAA;AACF;AAEA;EACE,WAAA;EACA,eAAA;EACA,sBAAA;AAAF","sourcesContent":[":host {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n}\n\n.wn-review {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
